module.exports = __webpack_public_path__ + "static/media/soloUnete.65caacbe.webp";